import _regeneratorRuntime from "/opt/build/repo/website/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { dispatch } from '../../dispatch';
import { QUEUE_EFFECT } from './constants';
export function effect(effectType, run, effectKind, selector) {
  // tslint:disable:promise-must-complete
  return Object.assign( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(effectPayload) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                // indirection is here to avoid circular dependencies within the framework
                dispatch({
                  type: QUEUE_EFFECT,
                  payload: {
                    effectType: effectType,
                    effect: effectPayload,
                    resolve: resolve,
                    reject: reject
                  }
                });
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), {
    effectType: effectType,
    effectKind: effectKind,
    run: run,
    selector: selector
  }); // tslint:enable:promise-must-complete
  // trust me 😎
}